export default {
    isLoading: (state) => (id) => {
        return state.loading.includes(id);
    },
    isAnyLoading: (state) => {
        return state.loading.length;
    },
};
